import { render, staticRenderFns } from "./PayoutResultPage.vue?vue&type=template&id=6ffa9da8&scoped=true"
import script from "./PayoutResultPage.vue?vue&type=script&lang=js"
export * from "./PayoutResultPage.vue?vue&type=script&lang=js"
import style0 from "./PayoutResultPage.vue?vue&type=style&index=0&id=6ffa9da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa9da8",
  null
  
)

export default component.exports